import { APICore } from './apiCore';

const api = new APICore();

const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, ''); 

function login(params: { username: string; password: string }) {
    const url = `${baseUrl}/auth/login`;
    return api.create(url, params);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { name: string, username: string; password: string; firstName: string; lastName: string }) {
    const url = `${baseUrl}/tenant`;
    return api.create(url, params);
}

function forgotPassword(params: { username: string }) {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

function forgotPasswordConfirm(params: { email: string }) {
    const baseUrl = '/password/reset/confirm/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword, forgotPasswordConfirm };
